import React, { useEffect, useState, useMemo } from "react";
import Badge from "react-bootstrap/Badge";
import Alert from "react-bootstrap/Alert";
import Table from "../../utils/Table";
import { fetchPortalUsers } from "../../services/api";
import { useToast } from "../../contexts/ToastContext";

function PortalUsersList() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [pageCount, setPageCount] = useState(0);
  const [pageIndex, setPageIndex] = useState(0);
  const [filterInput, setFilterInput] = useState("");
  const { showToast } = useToast();

  const pageSize = 20;

  const fetchData = async () => {
    setLoading(true);
    setError("");
    try {
      const response = await fetchPortalUsers(pageIndex + 1, filterInput);
      setData(response?.users || []);
      setPageCount(response?.totalPages || 0);
    } catch (err) {
      console.error("Error fetching portal users:", err);
      setError("Failed to fetch portal users.");
      showToast("Error loading portal users", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [pageIndex, filterInput]);

  const columns = useMemo(() => [
    {
      Header: "Date Registered",
      accessor: "createdAt",
      Cell: ({ value }) => {
        if (!value) return "N/A";
        return new Date(value).toLocaleDateString("en-US", {
          year: "numeric",
          month: "short",
          day: "numeric",
        });
      }
    },
    {
      Header: "User ID",
      accessor: "id",
      Cell: ({ value }) => value?.toString().padStart(3, "0")
    },
    {
      Header: "Email Address",
      accessor: "email",
    },
    {
      Header: "Password Status",
      accessor: "mustChangePassword",
      Cell: ({ value }) => {
        return value === 1 ? (
          <Badge bg="warning" text="dark">Temp Password Active</Badge>
        ) : (
          <Badge bg="success">Password Set</Badge>
        );
      }
    }
  ], []);

  const handlePageChange = (newPageIndex) => {
    setPageIndex(newPageIndex);
  };

  return (
    <div className="subMain-content">
      <div>
        <h1 className="mt-4">Portal Applicant Users</h1>
      </div>

      {error && <Alert variant="danger">{error}</Alert>}

      <Table
        columns={columns}
        data={data}
        filterInput={filterInput}
        setFilterInput={setFilterInput}
        pageCount={pageCount}
        loading={loading}
        onPageChange={handlePageChange}
        currentPage={pageIndex}
      />
    </div>
  );
}

export default PortalUsersList;
